module.exports = __webpack_public_path__ + "coin2.mp3";